import { runInAction } from 'mobx';
import { getOrder } from '../../../selectors/order/get-order';
import { orderDomainStore } from '../../../store';
import { assertIsOrderCreated } from '../../../utils/order-type-utils';
/**
 * Stores an added [[OrderVoucher]], along with its redemption details.
 */
export const storeOrderVoucher = (details) => {
    const { voucher, availableRedemptions } = details;
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot store order voucher');
    runInAction(() => {
        order.vouchers.push(voucher);
        orderDomainStore.data.orderVoucherRedemptionDetailsById[voucher.id] = {
            voucherId: voucher.id,
            addedAt: new Date(),
            availableRedemptions
        };
    });
};
